import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';
import 'static/script/libs/owl.carousel.custom';

function CarouselUI() {
    let SLIDESHOW_SPEED = 5000;
    let ACTION_TYPES = ['drag', 'arrow', 'paginate', 'play'];
    let displayedSlideIndexes = [];

    this.defaultAttrs({
        item: '[data-carousel-item]',
        image: '.product-image',
        unloadedImage: '.lazyOwl',
        loading: '.loading',
        lazyBannerCss: 'carousel-banner-lazy',
        next: '.owl-next',
        previous: '.owl-prev',
        bannerTexts: '.owl-item [data-banner-title]',
        bannerTextDataAttribute: 'banner-title',
        activeBannerText: '.owl-item.active [data-banner-title]'
    });

    this._stopCarousel = function () {
        this.$node.trigger('owl.stop');
    };

    this._startCarousel = function () {
        this.$node.trigger('owl.play', SLIDESHOW_SPEED);
    };

    this._trackPagination = function (action) {

        let activeBannerText = this.select('activeBannerText');
        let bannerTexts = this.select('bannerTexts');
        let activeBannerIndex = bannerTexts.index(activeBannerText);

        this.trigger(document, 'analytics:track-event', {
            category: 'Carousel - Start page',
            action: 'Interaction',
            label: action,
            value: activeBannerIndex + 1
        });
    };

    this._trackSlideDisplay = function () {

        let activeBannerText = this.select('activeBannerText');
        let bannerTexts = this.select('bannerTexts');
        let activeBannerIndex = bannerTexts.index(activeBannerText);

        if (displayedSlideIndexes.indexOf(activeBannerIndex) < 0) {
            displayedSlideIndexes.push(activeBannerIndex);

            this.trigger(document, 'analytics:track-event', {
                category: 'Carousel - Start page',
                action: 'Show ' + (activeBannerIndex + 1),
                label: activeBannerText.data(this.attr.bannerTextDataAttribute).trim()
            });
        }
    };

    this._loadBackgroundImages = function () {
        let banners = this.select('item');
        let hiddenCssClass = this.attr.lazyBannerCss;

        setTimeout(function () {
            banners.each(function () {
                $(this).removeClass(hiddenCssClass);
            });
        }, 1000);
    };

    this._afterMove = function ($elem, actionType) {
        if (ACTION_TYPES.indexOf(actionType) >= 0 && actionType !== 'play') {
            this._stopCarousel();
            this._trackPagination(actionType || 'unknown');
        }
        this._trackSlideDisplay();
    };

    this._afterInit = function () {
        this._loadBackgroundImages();
        this._trackSlideDisplay();
    };

    this._doTeardown = function () {
        let owl = this.$node.data('owlCarousel');
        if (owl && owl.destroy) {
            owl.destroy();
        }
    };

    this.after('initialize', function () {
        this.$node.owlCarousel({
            autoPlay: SLIDESHOW_SPEED,
            stopOnHover: true,
            singleItem: true,
            pagination: true,
            navigation: true,
            addClassActive: true,
            support3d: window.Feature.detected['hardware-acceleration-ok'],
            afterInit: this._afterInit.bind(this),
            afterMove: this._afterMove.bind(this)
        });

        this.on(document, 'ui:mega-categories-on-show ui:site-header:on-hamburger-click', this._stopCarousel);
        this.on(document, 'ui:mega-categories-on-hide ui:side-menu:on-side-menu-close-click', this._startCarousel);
        this.on(document, 'ui:teardown', this._doTeardown);
    });
}

module.exports = defineComponent.component(CarouselUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/carousel-ui.js